import {
  ArrowLeft,
  Mail,
  Phone,
  MapPin,
  Send,
  MessageSquare,
  Clock,
  HelpCircle,
  Building2,
  Headphones,
  ExternalLink,
  ChevronRight,
  BookOpen,
  LifeBuoy,
  FileQuestion,
} from "lucide-react";
import Footer from "../../ui/Footer/Footer";
import { Link } from "react-router-dom";
import { useState } from "react";
import styles from "./Contact.module.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(
      "Thank you for your message! We will get back to you within 24 hours.",
    );
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div className={styles.container}>
      {/* Hero */}
      <div className={styles.heroBanner}>
        <div className={styles.heroInner}>
          <div className={styles.heroNav}>
            <Link to="/" className={styles.backLink}>
              <ArrowLeft size={16} />
              Back to Home
            </Link>
          </div>
          <h1 className={styles.heroTitle}>Contact & Support</h1>
          <p className={styles.heroSubtitle}>
            Get help from our team, explore self-service resources, or reach out
            directly. We're here to support your workflow.
          </p>
        </div>
      </div>

      {/* Tab Bar */}
      <div className={styles.tabBar}>
        <button className={`${styles.tab} ${styles.tabActive}`}>
          Contact Us
        </button>
        <Link to="/HelpCenter" className={styles.tab}>
          Help Center
        </Link>
        {/* <Link to="/issues" className={styles.tab}>
          Report an Issue
        </Link> */}
      </div>

      <div className={styles.mainContent}>
        {/* Quick Cards */}
        <div className={styles.quickCards}>
          <div className={styles.quickCard}>
            <div className={`${styles.quickCardIcon} ${styles.iconBlue}`}>
              <Mail size={20} />
            </div>
            <h3>Email Support</h3>
            <p>Get a response within 24 hours on business days.</p>
            <span className={styles.quickCardLink}>
              support@viewstruct.com <ChevronRight size={14} />
            </span>
          </div>
          <div className={styles.quickCard}>
            <div className={`${styles.quickCardIcon} ${styles.iconOrange}`}>
              <Phone size={20} />
            </div>
            <h3>Phone Support</h3>
            <p>Mon–Fri, 9:00 AM – 6:00 PM (GMT+4)</p>
            <span className={styles.quickCardLink}>
              +374 10 123 456 <ChevronRight size={14} />
            </span>
          </div>
          <div className={styles.quickCard}>
            <div className={`${styles.quickCardIcon} ${styles.iconGreen}`}>
              <MessageSquare size={20} />
            </div>
            <h3>Live Chat</h3>
            <p>Instant help during business hours.</p>
            <span className={styles.quickCardLink}>
              Start a conversation <ChevronRight size={14} />
            </span>
          </div>
          <div className={styles.quickCard}>
            <div className={`${styles.quickCardIcon} ${styles.iconPurple}`}>
              <BookOpen size={20} />
            </div>
            <h3>Help Center</h3>
            <p>Browse articles, guides, and tutorials.</p>
            <Link to="/HelpCenter" className={styles.quickCardLink}>
              Explore resources <ChevronRight size={14} />
            </Link>
          </div>
        </div>

        {/* Form + Sidebar */}
        <div className={styles.twoCol}>
          <div className={styles.formCard}>
            <div className={styles.formCardHeader}>
              <div className={styles.formCardIcon}>
                <Send size={16} />
              </div>
              <h2 className={styles.formCardTitle}>Send a Message</h2>
            </div>
            <p className={styles.formCardDesc}>
              Fill out the form and our team will get back to you shortly.
            </p>
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label htmlFor="firstName">First Name *</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    placeholder="John"
                  />
                </div>
                <div className={styles.formGroup}>
                  <label htmlFor="lastName">Last Name *</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    placeholder="Smith"
                  />
                </div>
              </div>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="john@company.com"
                  />
                </div>
                <div className={styles.formGroup}>
                  <label htmlFor="company">Company</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Company name"
                  />
                </div>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="subject">Subject *</label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a topic</option>
                  <option value="general">General Inquiry</option>
                  <option value="support">Technical Support</option>
                  <option value="sales">Sales & Pricing</option>
                  <option value="enterprise">Enterprise Solutions</option>
                  <option value="partnership">Partnership</option>
                  <option value="feedback">Feedback</option>
                  <option value="bug">Bug Report</option>
                </select>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Describe how we can help..."
                />
              </div>
              <button type="submit" className={styles.submitBtn}>
                <Send size={16} />
                Send Message
              </button>
            </form>
          </div>

          {/* Sidebar */}
          <div className={styles.sidebar}>
            <div className={styles.sideCard}>
              <div className={styles.sideCardTitle}>
                <LifeBuoy size={18} /> Contact Details
              </div>
              <div className={styles.contactItem}>
                <div className={styles.contactItemIcon}>
                  <Mail size={14} />
                </div>
                <div className={styles.contactItemText}>
                  <strong>Email</strong>
                  <a href="mailto:support@viewstruct.com">
                    support@viewstruct.com
                  </a>
                </div>
              </div>
              <div className={styles.contactItem}>
                <div className={styles.contactItemIcon}>
                  <Phone size={14} />
                </div>
                <div className={styles.contactItemText}>
                  <strong>Phone</strong>
                  <a href="tel:+37410123456">+374 10 123 456</a>
                </div>
              </div>
              <div className={styles.contactItem}>
                <div className={styles.contactItemIcon}>
                  <Clock size={14} />
                </div>
                <div className={styles.contactItemText}>
                  <strong>Business Hours</strong>
                  <span>Mon–Fri, 9 AM – 6 PM (GMT+4)</span>
                </div>
              </div>
              <div className={styles.hoursBadge}>
                <span className={styles.hoursDot}></span>
                Available Now
              </div>
            </div>

            {/* <div className={styles.sideCard}>
              <div className={styles.sideCardTitle}>
                <Building2 size={18} /> Our Offices
              </div>
              <div className={styles.officeItem}>
                <h4>
                  <MapPin size={14} /> Yerevan, Armenia (HQ)
                </h4>
                <p>
                  26 Vazgen Sargsyan Street
                  <br />
                  Yerevan 0010, Armenia
                </p>
              </div>
              <div className={styles.officeItem}>
                <h4>
                  <MapPin size={14} /> Dubai, UAE
                </h4>
                <p>
                  Business Bay, Tower A, Floor 12
                  <br />
                  Dubai, United Arab Emirates
                </p>
              </div>
            </div> */}

            <div className={styles.sideCard}>
              <div className={styles.sideCardTitle}>
                <Headphones size={18} /> Support Tiers
              </div>
              <div className={styles.contactItem}>
                <div className={styles.contactItemText}>
                  <strong>Standard Support</strong>
                  <span>24h response, Mon–Fri</span>
                </div>
              </div>
              <div className={styles.contactItem}>
                <div className={styles.contactItemText}>
                  <strong>Enterprise Support</strong>
                  <span>4h response, priority SLA</span>
                </div>
              </div>
              <div className={styles.contactItem}>
                <div className={styles.contactItemText}>
                  <strong>Emergency</strong>
                  <span>24/7 for critical issues</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className={styles.faqSection}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>
              <HelpCircle size={20} /> Frequently Asked Questions
            </h2>
          </div>
          <div className={styles.faqGrid}>
            <div className={styles.faqCard}>
              <h4>
                <FileQuestion size={16} /> What file formats are supported?
              </h4>
              <p>
                IFC, RVT, DWG, DXF, OBJ, FBX, STEP, STL and many other popular
                CAD/BIM formats with automatic conversion.
              </p>
            </div>
            <div className={styles.faqCard}>
              <h4>
                <FileQuestion size={16} /> How fast is support response?
              </h4>
              <p>
                Standard support responds within 24 hours. Enterprise customers
                get priority responses within 4 hours.
              </p>
            </div>
            <div className={styles.faqCard}>
              <h4>
                <FileQuestion size={16} /> Do you offer team plans?
              </h4>
              <p>
                Yes — flexible team and enterprise plans with custom storage,
                SSO, and dedicated account management.
              </p>
            </div>
            <div className={styles.faqCard}>
              <h4>
                <FileQuestion size={16} /> Is my data secure?
              </h4>
              <p>
                AES-256 encryption at rest, TLS 1.3 in transit. SOC 2 Type II
                certified infrastructure with 24/7 monitoring.
              </p>
            </div>
            <div className={styles.faqCard}>
              <h4>
                <FileQuestion size={16} /> Can I try viewStruct for free?
              </h4>
              <p>
                Free tier includes 5GB storage and essential features. Upgrade
                anytime as your needs grow.
              </p>
            </div>
            <div className={styles.faqCard}>
              <h4>
                <FileQuestion size={16} /> How do I report a bug?
              </h4>
              <p>
                Use the Issues page or select "Bug Report" in the contact form.
                Include steps to reproduce for faster resolution.
              </p>
            </div>
          </div>
        </div>

        {/* CTA Banner */}
        <div className={styles.ctaBanner}>
          <div className={styles.ctaText}>
            <h3>Ready to Transform Your Workflow?</h3>
            <p>
              Join thousands of professionals who trust viewStruct for 3D/BIM
              visualization.
            </p>
          </div>
          <div className={styles.ctaActions}>
            <button className={styles.ctaBtnPrimary}>
              <Headphones size={16} />
              Schedule Demo
            </button>
            <Link to="/HelpCenter" className={styles.ctaBtnSecondary}>
              <BookOpen size={16} />
              Help Center
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;
